@import "../../variables.scss";

.radioButton {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &__label {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  &__disabled {
    color: lightgrey;
  }

  &__checkmark {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    background-color: white;
    border: 1px solid #d9d9d9;
    &:hover {
      background-color: rgb(218, 216, 216);
    }
  }
}

.radioButton__label {
  input:checked ~ .radioButton__checkmark {
    border-radius: 50%;
    background-color: $color-orange;
  }
}

.radioButton__checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.radioButton__label {
  input:checked ~ .radioButton__checkmark:after {
    display: block;
  }
}

.radioButton__label .radioButton__checkmark:after {
  left: 8px;
  top: 8px;
  width: 5px;
  height: 5px;
  border: solid white;
  border-width: 3px;
  border-radius: 50%;
}
